import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import EzDialog from "../../../../common/EzDialog";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import EzControlledDropDownWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import EzControlledInputAreaWithFloatingLabel from "../../../../common/EzForm/EzControlledInputArea/WithFloatingLabel";


const paymentMethodOptions = [
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "Check", value: "check" },
  { label: "Cash", value: "cash" },
  { label: "Credit Card", value: "credit_card" },
  { label: "Wire Transfer", value: "wire_transfer" },
  { label: "Other", value: "other" },
];

const paymentStatusOptions = [
  { label: "Paid", value: "paid" },
  { label: "Pending", value: "pending" },
  { label: "Failed", value: "failed" },
  { label: "Refunded", value: "refunded" },
];

const ViewPaymentDialog = ({ visible, onHide, payment }) => {
  const { control, reset } = useForm({
    defaultValues: {
      paidAmount: null,
      paymentDate: null,
      paymentMethod: null,
      paymentStatus: null,
      reason: "",
      additionalInfo: "",
    },
  });

  useEffect(() => {
    if (visible && payment) {
      reset({
        paidAmount: payment.paidAmount ?? null,
        paymentDate: payment.paymentDate ? new Date(payment.paymentDate) : null,
        paymentMethod: payment.paymentMethod ?? null,
        paymentStatus: payment.paymentStatus ?? null,
        reason: payment.reason ?? "",
        additionalInfo: payment.additionalInfo ?? "",
      });
    } else if (!visible) {
      reset();
    }
  }, [visible, payment, reset]);

  return (
    <EzDialog
      header="View Payment"
      visible={visible}
      onHide={onHide}
      width="600px"
      height="auto"
      maximizable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            label="Close"
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={onHide}
          />
        </div>
      }
    >
      <div className="form-demo" style={{ paddingBottom: 0 }}>
        <form className="p-fluid">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <EzControlledInputWithFloatingLabel
                name="paidAmount"
                control={control}
                label="Paid Amount ($)"
                labelClassName="ml-2"
                type="number"
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <EzControlledCalendarWithFloatingLabel
                name="paymentDate"
                control={control}
                label="Payment Date"
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <EzControlledDropDownWithFloatingLabel
                name="paymentMethod"
                control={control}
                optionLabel="label"
                optionValue="value"
                options={paymentMethodOptions}
                label="Payment Method"
                labelClassName="ml-2"
                shouldFilter={false}
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <EzControlledDropDownWithFloatingLabel
                name="paymentStatus"
                control={control}
                optionLabel="label"
                optionValue="value"
                options={paymentStatusOptions}
                label="Payment Status"
                labelClassName="ml-2"
                shouldFilter={false}
                disabled
              />
            </Grid>

            <Grid item xs={12}>
              <EzControlledInputWithFloatingLabel
                name="reason"
                control={control}
                label="Reason"
                labelClassName="ml-2"
                type="text"
                disabled
              />
            </Grid>

            <Grid item xs={12}>
              <EzControlledInputAreaWithFloatingLabel
                name="additionalInfo"
                control={control}
                label="Additional Info"
                labelClassName="ml-2"
                rows={3}
                disabled
              />
            </Grid>
          </Grid>
        </form>
      </div>
    </EzDialog>
  );
};

export default ViewPaymentDialog;
